import { makeStyles } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

export const useServiceUnavailableStyles = makeStyles(() =>
  createStyles({
      root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 99999,
      position: 'relative',
      }
  })
)
